<script setup lang="ts">
import { MMIcon, MMPopupDefault, MMText, MMTimer } from '@mm-frontend/mm-web-ui-kit';
import { ButtonSecondaryNeutral } from '~/features/ui-kit';
import { useSignIn } from '../business/useSignIn';
import CodeInput from '~/features/ui-kit/form/ui/CodeInput.vue';
import { formatPhone } from '~/shared/helpers/formatPhone';

const { signInCodeStep, goToPhoneStep } = useSignIn();

const { sendedOtpData, formData, codeStepOtpError, submitCode, allowRetry, retryCode, isRetryLoading, isRetryFormValid, retryAfter, renderCaptcha } = signInCodeStep;

const sendedToPhone = ref<string | undefined>(undefined);

onMounted(() => {
  sendedToPhone.value = sendedOtpData.value?.phone;
});

watch(allowRetry, (payload) => {
  if (payload) {
    nextTick(() => {
      renderCaptcha();
    });
  }
}, { immediate: true });
</script>

<template>
  <MMPopupDefault class="popup">
    <template #header>
      <MMIcon name="chevron-multicolor" class="popup-header__back" :height="24" :width="24" @click="goToPhoneStep" />

      <MMText font="Title L/Semibold" label="Введите код из СМС" class="popup-header__title" />
      <MMText v-if="sendedToPhone" font="Body L/Regular" :label="`Отправили на номер ${formatPhone(sendedToPhone || '')}`" />
    </template>

    <div class="popup-content">
      <CodeInput v-model="formData.code.value" :error="codeStepOtpError" @filled="submitCode" @update:model-value="codeStepOtpError = ''" />
      <div v-show="allowRetry" id="yandex-captcha-code" />
    </div>

    <template #footer>
      <div v-if="!allowRetry" class="popup-footer__timer">
        <MMText font="Body M/Regular" label="Новый код через" />
        <MMTimer :expires-at="retryAfter" :show-hours="false" />
      </div>

      <ButtonSecondaryNeutral v-else-if="allowRetry" w100 size="l48" :loading="isRetryLoading" :disabled="!isRetryFormValid" @click="retryCode">
        Получить новый код
      </ButtonSecondaryNeutral>
    </template>
  </MMPopupDefault>
</template>

<style scoped lang="stylus">
.popup
  width 480px
  height 520px

  +Media(Mobile)
    max-width calc(100vw - 32px)

  &-header
    &__back
      margin-bottom 18px
      justify-content flex-start

    &__title
      margin-bottom 6px

  &-content
    margin-top 28px
    margin-bottom 20px

    #yandex-captcha-code
      margin-top 16px

  &-footer
    &__timer
      display flex
      align-items center
      justify-content center
      gap 8px

    // &__button
    //   margin-top 16px
</style>